/* eslint-disable import/order */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Col, Row } from 'react-bootstrap';
import { MdAdd, MdCheckCircle, MdEdit } from 'react-icons/md';
import AppSelect from '../../../shared/components/app-select/AppSelect';
import AppTextInput from '../../../shared/components/app-text-input/AppTextInput';
import {
  API_DATE_FORMAT,
  checkValidName,
  checkValidPassport,
  TODAY_DATE,
} from '../../../shared/constants/Constants';
import {
  formatDate,
  getNewDate,
  isEmpty,
} from '../../../shared/helper-utils/appUtils';
import AppButton from '../../../shared/components/app-button/AppButton';
import AppAlert from '../../../shared/components/app-alert/AppAlert';
import { getValueFromAppConfig } from '../../../shared/helper-utils/localStorage';

function HotelPassengerDetailsLeadGuest({
  passengerList,
  onPassengerUpdate,
  passengerErrorDict,
  isPassport,
  isPan,
}) {
  const intl = useIntl();
  const formattedMessage = (message) => intl.formatMessage({ id: message });

  const getKey = (roomIndex, room, paxIndex) =>
    roomIndex * room.roomPassengers.paxList.length + paxIndex;
  const isDefaultGuestDetails = (pax) =>
    pax.title === 'Mr' && pax.firstName === 'TBA' && pax.lastName === 'TBA';
  const getPaxWithDefaultDetails = (pax, key) => {
    if (key === 0 || !isEmpty(pax.firstName) || !isEmpty(pax.lastName)) {
      return pax;
    }

    return {
      ...pax,
      title: 'Mr',
      firstName: 'TBA',
      lastName: 'TBA',
    };
  };
  const getPassengerListWithDefaultGuests = (rooms) =>
    rooms.map((room, roomIndex) => ({
      ...room,
      roomPassengers: {
        ...room.roomPassengers,
        paxList: room.roomPassengers.paxList.map((pax, paxIndex) =>
          getPaxWithDefaultDetails(pax, getKey(roomIndex, room, paxIndex)),
        ),
      },
    }));

  const [passengers, setPassengers] = useState(() =>
    getPassengerListWithDefaultGuests(passengerList),
  );
  const [expandedKey, setExpandedKey] = useState('');
  const [inlineForm, setInlineForm] = useState(undefined);
  const [inlineAlert, setInlineAlert] = useState(undefined);

  const TITLE_OPTIONS = [
    { label: formattedMessage('mr'), value: 'Mr' },
    { label: formattedMessage('ms'), value: 'Ms' },
    { label: formattedMessage('mrs'), value: 'Mrs' },
  ];
  const CHILD_TITLE_OPTIONS = [
    { label: formattedMessage('mstr'), value: 'Mstr' },
    { label: formattedMessage('ms'), value: 'Ms' },
  ];

  useEffect(() => {
    if (onPassengerUpdate) {
      onPassengerUpdate(passengers);
    }
  }, [passengers]);

  const getTitleOptions = (pax) =>
    pax.paxType === '2' ? CHILD_TITLE_OPTIONS : TITLE_OPTIONS;

  const isGuestFilled = (pax) =>
    !isDefaultGuestDetails(pax) &&
    (!isEmpty(pax.title) || !isEmpty(pax.firstName) || !isEmpty(pax.lastName));
  const getFormattedPanNumber = (panNumber) =>
    panNumber?.replace(/\s/g, '').toUpperCase() || '';

  const handleDropdownChange = (value, name, roomIndex, paxIndex) => {
    const updatedValue = value !== null ? value.value : '';
    const roomList = [...passengers];
    roomList[roomIndex].roomPassengers.paxList[paxIndex][name] = updatedValue;
    setPassengers(roomList);
  };

  const handleChange = (event, roomIndex, paxIndex) => {
    const { name, value } = event.target;
    const roomList = [...passengers];
    roomList[roomIndex].roomPassengers.paxList[paxIndex][name] =
      name === 'panCardNumber' ? getFormattedPanNumber(value) : value;
    setPassengers(roomList);
  };

  const openInlineForm = (pax, roomIndex, paxIndex) => {
    setExpandedKey(`${roomIndex}-${paxIndex}`);
    setInlineForm({
      ...pax,
      title: isDefaultGuestDetails(pax) ? '' : pax.title,
      firstName: pax.firstName === 'TBA' ? '' : pax.firstName,
      lastName: pax.lastName === 'TBA' ? '' : pax.lastName,
      roomIndex,
      paxIndex,
    });
    setInlineAlert(undefined);
  };

  const handleInlineTitleChange = (event) => {
    setInlineForm((prev) => ({
      ...prev,
      title: event ? event.value : '',
    }));
  };

  const handleInlineInputChange = (event) => {
    const { name, value } = event.target;
    setInlineForm((prev) => ({
      ...prev,
      [name]: name === 'panCardNumber' ? getFormattedPanNumber(value) : value,
    }));
  };

  const PAN_REGAX = /^[A-Za-z]{5}[0-9]{4}[A-Za-z]$/;
  const isValidPanNumber = (panNumber) =>
    PAN_REGAX.test(getFormattedPanNumber(panNumber));
  const getPanValidationText = (panNumber) => {
    if (isEmpty(getFormattedPanNumber(panNumber))) {
      return '';
    }

    return isValidPanNumber(panNumber)
      ? 'PAN number is valid'
      : 'Enter valid PAN number';
  };

  const handleSaveGuest = () => {
    const updatedInlineForm = {
      ...inlineForm,
      panCardNumber: getFormattedPanNumber(inlineForm.panCardNumber),
      title: inlineForm.title || 'Mr',
      firstName: inlineForm.firstName || 'TBA',
      lastName: inlineForm.lastName || 'TBA',
    };
    const hasEnteredFirstName = updatedInlineForm.firstName !== 'TBA';
    const hasEnteredLastName = updatedInlineForm.lastName !== 'TBA';

    const isLastNameValidationEnabled =
      getValueFromAppConfig('ENABLE_LASTNAME_VALIDATION') === 'true';

    if (
      (hasEnteredFirstName && checkValidName(updatedInlineForm.firstName)) ||
      (hasEnteredLastName && checkValidName(updatedInlineForm.lastName))
    ) {
      setInlineAlert({
        variant: 'danger',
        title: 'Add Guest',
        description: 'Please enter valid guest details.',
      });
      return;
    }

    if (
      isLastNameValidationEnabled &&
      hasEnteredLastName &&
      updatedInlineForm.lastName.trim().length < 2
    ) {
      setInlineAlert({
        variant: 'danger',
        title: 'Add Guest',
        description: 'Last name must be at least 2 letters.',
      });
      return;
    }

    if (
      isPassport &&
      updatedInlineForm.ppNumber &&
      !checkValidPassport(updatedInlineForm.ppNumber)
    ) {
      setInlineAlert({
        variant: 'danger',
        title: 'Add Guest',
        description: 'Please enter valid passport number.',
      });
      return;
    }

    if (
      isPan &&
      updatedInlineForm.paxType === '1' &&
      updatedInlineForm.panCardNumber &&
      !isValidPanNumber(updatedInlineForm.panCardNumber)
    ) {
      setInlineAlert({
        variant: 'danger',
        title: 'Add Guest',
        description: 'Please enter valid PAN number.',
      });
      return;
    }

    const roomList = [...passengers];
    const { roomIndex, paxIndex, ...updatedPax } = updatedInlineForm;
    roomList[roomIndex].roomPassengers.paxList[paxIndex] = updatedPax;
    setPassengers(roomList);
    setExpandedKey('');
    setInlineForm(undefined);
    setInlineAlert(undefined);
  };

  return (
    <section className="hbp-guest-list">
      {passengers.map((room, roomIndex) => (
        <div key={roomIndex} className="hbp-guest-room">
          {passengers.length > 1 && (
            <div className="hbp-guest-room__label">Room {roomIndex + 1}</div>
          )}

          {room.roomPassengers.paxList.map((pax, paxIndex) => {
            const key = getKey(roomIndex, room, paxIndex);
            const error = passengerErrorDict[key] || {};

            if (key === 0) {
              return (
                <div
                  key={paxIndex}
                  className="hbp-guest-card hbp-guest-card--lead"
                >
                  <div className="hbp-guest-card__header">
                    <span className="hbp-guest-card__label">Lead Guest</span>
                    <span className="hbp-guest-card__required">* Required</span>
                  </div>
                  <Row className="spacing-8">
                    <Col lg={2} md={2} sm={3} xs={4}>
                      <AppSelect
                        label={formattedMessage('title')}
                        placeholder=""
                        classNamePrefix="hotel-booking-title"
                        className="app-select"
                        name="title"
                        options={getTitleOptions(pax)}
                        selectedValue={pax.title}
                        onSelect={(value) =>
                          handleDropdownChange(
                            value,
                            'title',
                            roomIndex,
                            paxIndex,
                          )
                        }
                        required
                        isClearable={false}
                        errorText={error.title}
                      />
                    </Col>
                    <Col lg={4} md={4} sm={4} xs={8}>
                      <AppTextInput
                        required
                        label={formattedMessage('first_name')}
                        value={pax.firstName}
                        name="firstName"
                        onChange={(e) => handleChange(e, roomIndex, paxIndex)}
                        errorText={error.firstName}
                      />
                      {checkValidName(pax.firstName) && (
                        <small className="app-error-text">
                          {formattedMessage('name_validation')}
                        </small>
                      )}
                    </Col>
                    <Col lg={4} md={4} sm={5} xs={12}>
                      <AppTextInput
                        required
                        label={formattedMessage('last_name')}
                        value={pax.lastName}
                        name="lastName"
                        onChange={(e) => handleChange(e, roomIndex, paxIndex)}
                        errorText={error.lastName}
                      />
                      {checkValidName(pax.lastName) && (
                        <small className="app-error-text">
                          {formattedMessage('name_validation')}
                        </small>
                      )}
                      {getValueFromAppConfig('ENABLE_LASTNAME_VALIDATION') ===
                        'true' &&
                        !checkValidName(pax.lastName) &&
                        pax.lastName.trim().length > 0 &&
                        pax.lastName.trim().length < 2 && (
                          <small className="app-error-text ps-1">
                            Last name must be 2+ letters
                          </small>
                        )}
                    </Col>
                    {pax.paxType !== '1' && (
                      <Col lg={3} md={3} sm={6} xs={6}>
                        <AppTextInput
                          label="Age"
                          className="dob-input"
                          readOnly
                          value={pax.age}
                          name="dob"
                        />
                      </Col>
                    )}
                    {isPassport && (
                      <>
                        <Col lg={3} md={3} sm={6} xs={6}>
                          <AppTextInput
                            required
                            label={formattedMessage('passport_number')}
                            value={pax.ppNumber}
                            name="ppNumber"
                            onChange={(e) =>
                              handleChange(e, roomIndex, paxIndex)
                            }
                            errorText={error.ppNumber}
                          />
                        </Col>
                        <Col lg={3} md={3} sm={6} xs={6}>
                          <AppTextInput
                            required
                            label={formattedMessage('passport_expiry')}
                            type="date"
                            name="ppExpiry"
                            min={formatDate(
                              getNewDate(TODAY_DATE),
                              API_DATE_FORMAT,
                            )}
                            value={pax.ppExpiry}
                            onChange={(e) =>
                              handleChange(e, roomIndex, paxIndex)
                            }
                            errorText={error.ppExpiry}
                          />
                        </Col>
                      </>
                    )}
                    {isPan && pax.paxType === '1' && (
                      <Col lg={3} md={3} sm={6} xs={6}>
                        <AppTextInput
                          required
                          label={formattedMessage('pan_number')}
                          name="panCardNumber"
                          value={pax.panCardNumber}
                          onChange={(e) => handleChange(e, roomIndex, paxIndex)}
                          errorText={error.panCardNumber}
                        />
                        {getPanValidationText(pax.panCardNumber) && (
                          <small
                            className={
                              isValidPanNumber(pax.panCardNumber)
                                ? 'hbp-guest-card__success-text'
                                : 'app-error-text'
                            }
                          >
                            {getPanValidationText(pax.panCardNumber)}
                          </small>
                        )}
                      </Col>
                    )}
                  </Row>
                </div>
              );
            }

            const filled = isGuestFilled(pax);
            const cardKey = `${roomIndex}-${paxIndex}`;
            const isExpanded = expandedKey === cardKey;
            const guestType = pax.paxType !== '1' ? 'Child' : 'Adult';

            return (
              <div
                key={paxIndex}
                className={`hbp-guest-card hbp-guest-card--additional${
                  filled ? ' hbp-guest-card--filled' : ''
                }`}
              >
                <div className="hbp-guest-card__row">
                  <div className="hbp-guest-card__guest-info">
                    {filled ? (
                      <>
                        <MdCheckCircle className="hbp-guest-card__check-icon" />
                        <span className="hbp-guest-card__guest-name">
                          {pax.title} {pax.firstName} {pax.lastName}
                        </span>
                        <span className="hbp-guest-card__guest-badge">
                          {guestType}
                        </span>
                      </>
                    ) : (
                      <span className="hbp-guest-card__guest-placeholder">
                        Guest {paxIndex + 1} ({guestType}){' '}
                        <span className="hbp-guest-card__optional">
                          Optional
                        </span>
                      </span>
                    )}
                  </div>
                  <button
                    type="button"
                    className={`hbp-guest-card__action-btn${
                      filled ? ' hbp-guest-card__action-btn--edit' : ''
                    }`}
                    onClick={() => openInlineForm(pax, roomIndex, paxIndex)}
                  >
                    {filled ? (
                      <>
                        <MdEdit /> Edit
                      </>
                    ) : (
                      <>
                        <MdAdd /> Add Guest
                      </>
                    )}
                  </button>
                </div>

                {isExpanded && inlineForm && (
                  <div className="hbp-guest-card__inline-form">
                    {inlineAlert && (
                      <AppAlert
                        showIcon
                        variant={inlineAlert.variant}
                        title={inlineAlert.title}
                        description={inlineAlert.description}
                        onHide={() => setInlineAlert(undefined)}
                      />
                    )}
                    <Row className="spacing-8 mt-2 p-2">
                      <Col lg={2} md={2} sm={3} xs={4}>
                        <AppSelect
                          label={formattedMessage('title')}
                          placeholder=""
                          classNamePrefix="hotel-booking-title"
                          className="app-select"
                          name="title"
                          options={getTitleOptions(inlineForm)}
                          selectedValue={inlineForm.title}
                          onSelect={handleInlineTitleChange}
                          isClearable={false}
                        />
                      </Col>
                      <Col lg={4} md={4} sm={4} xs={8}>
                        <AppTextInput
                          label={formattedMessage('first_name')}
                          value={inlineForm.firstName}
                          name="firstName"
                          onChange={handleInlineInputChange}
                        />
                      </Col>
                      <Col lg={4} md={4} sm={5} xs={12}>
                        <AppTextInput
                          label={formattedMessage('last_name')}
                          value={inlineForm.lastName}
                          name="lastName"
                          onChange={handleInlineInputChange}
                        />
                      </Col>
                      {inlineForm.paxType !== '1' && (
                        <Col lg={2} md={2} sm={3} xs={4}>
                          <AppTextInput
                            label="Age"
                            className="dob-input"
                            readOnly
                            value={inlineForm.age}
                            name="dob"
                          />
                        </Col>
                      )}
                      {isPassport && (
                        <>
                          <Col lg={3} md={3} sm={6} xs={6}>
                            <AppTextInput
                              label={formattedMessage('passport_number')}
                              value={inlineForm.ppNumber}
                              name="ppNumber"
                              onChange={handleInlineInputChange}
                            />
                          </Col>
                          <Col lg={3} md={3} sm={6} xs={6}>
                            <AppTextInput
                              label={formattedMessage('passport_expiry')}
                              type="date"
                              name="ppExpiry"
                              min={formatDate(
                                getNewDate(TODAY_DATE),
                                API_DATE_FORMAT,
                              )}
                              value={inlineForm.ppExpiry}
                              onChange={handleInlineInputChange}
                            />
                          </Col>
                        </>
                      )}
                      {isPan && inlineForm.paxType === '1' && (
                        <Col lg={3} md={3} sm={6} xs={6}>
                          <AppTextInput
                            label={formattedMessage('pan_number')}
                            name="panCardNumber"
                            value={inlineForm.panCardNumber}
                            onChange={handleInlineInputChange}
                          />
                          {getPanValidationText(inlineForm.panCardNumber) && (
                            <small
                              className={
                                isValidPanNumber(inlineForm.panCardNumber)
                                  ? 'hbp-guest-card__success-text'
                                  : 'app-error-text'
                              }
                            >
                              {getPanValidationText(inlineForm.panCardNumber)}
                            </small>
                          )}
                        </Col>
                      )}
                      <Col lg={2} md={2} sm={3} xs={4} className="d-flex">
                        <AppButton
                          btnText="Save Guest"
                          className="fs-16"
                          onClick={handleSaveGuest}
                        />
                      </Col>
                    </Row>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ))}
    </section>
  );
}

HotelPassengerDetailsLeadGuest.propTypes = {
  passengerList: PropTypes.array.isRequired,
  onPassengerUpdate: PropTypes.func.isRequired,
  passengerErrorDict: PropTypes.object.isRequired,
  isPan: PropTypes.bool.isRequired,
  isPassport: PropTypes.bool.isRequired,
};

export default HotelPassengerDetailsLeadGuest;
